module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "AfterSaleSendBackView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AfterSaleSendBackView!./src/pages/Shop/Member/TradeManage/AfterSale/AfterSaleDetail/SendBack/index.js
// module id = 1977
// module chunks = 367